/* product-promo-widgets.js — extracted from repeated inline <script> blocks
   in templates/product.json and templates/product.men.json.
   Loaded once (deferred) and cached, instead of duplicated inline on every product page. */

/* Closing sale top banner countdown */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function updateCountdown() {
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var diff = end - now;
    if (diff < 0) diff = 0;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var el = document.getElementById('countdown-timer');
    if (el) el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);
})();

/* Rating box animated counter */
(function() {
  function animateCount(el, target, opts) {
    opts = opts || {};
    var decimals = opts.decimals || 0;
    var duration = opts.duration || 1200;
    var start = performance.now();
    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out
      var value = target * eased;
      el.textContent = decimals ? value.toFixed(decimals) : Math.round(value).toLocaleString('en-US');
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var boxes = document.querySelectorAll('.rating-box');
  if (!boxes.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var box = entry.target;
      if (box.dataset.animated) return;
      box.dataset.animated = 'true';
      box.classList.add('is-visible');

      var rating = parseFloat(box.dataset.rating);
      var reviews = parseInt(box.dataset.reviews, 10);
      var ratingEl = box.querySelector('.rating-count');
      var reviewsEl = box.querySelector('.reviews-count');

      if (ratingEl) animateCount(ratingEl, rating, { decimals: 1, duration: 1000 });
      if (reviewsEl) animateCount(reviewsEl, reviews, { decimals: 0, duration: 1400 });

      observer.unobserve(box);
    });
  }, { threshold: 0.4 });

  boxes.forEach(function(box) { observer.observe(box); });
})();

/* Stock alert countdown */
(function () {

    const stock = document.getElementById("stock-count");
    let current = Math.floor(Math.random() * 3) + 6; // começa entre 6 e 8

    stock.textContent = current;

    function updateStock() {

        if (current > 2) {
            current--;
        } else {
            current = Math.floor(Math.random() * 3) + 6; // reinicia entre 6 e 8
        }

        stock.textContent = current;

        // tempo aleatório entre 25 e 60 segundos
        const delay = Math.floor(Math.random() * 35000) + 25000;

        setTimeout(updateStock, delay);
    }

    setTimeout(updateStock, 30000);

})();

/* Shipping date badge */
(function () {
    function updateShippingDate() {
      let today = new Date();
      today.setDate(today.getDate() + 1);
      let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let day = days[today.getDay()];
      let date = today.getDate();
      document.getElementById("shipping-date").innerText = `${day}. ${date}`;
    }
    updateShippingDate();
  
})();
